import { EpimsBaseEntityDto } from './epim-base.dto';
export class ItemTypeDto extends EpimsBaseEntityDto {

    ItemTypeId: string;

    ItemTypeName: string;
   
    SubscriptionUserId: string;
    
    length : number;
    Version: number;
}